/* eslint-disable no-nested-ternary */

import _includes from 'lodash/includes';
import React, { Component } from 'react';
import { Button } from 'antd';
import { withApollo } from '@apollo/react-hoc';
import { gql } from '@apollo/client';
import keyMirror from 'keymirror';
import pluralize from 'pluralize';
import ReactJson from 'react-json-view';

const IMPORT_STATUS = keyMirror({
  ready: null,
  waiting: null,
  done: null,
});

const STAFF_ITEMS_IMPORT = gql`
  mutation StaffItemsImport($input: ItemsImportInput!) {
    itemsImport(input: $input) {
      errors
      createCount
      updateCount
      deleteCount
    }
  }
`;

const COLLAPSED_NAMES = ['lineObj', 'item', 'evaluated'];

const shouldCollapse = ({ name, _src, _namespace, _type }) => {
  return _includes(COLLAPSED_NAMES, name);
};

class FlashcardsImport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      importStatus: IMPORT_STATUS.ready,
    };
  }

  handleImport = async ({ execute = false }) => {
    const { client, productUuid } = this.props;
    const { file } = this.state;
    this.setState({
      importStatus: IMPORT_STATUS.waiting,
    });

    const { data } = await client.mutate({
      mutation: STAFF_ITEMS_IMPORT,
      variables: {
        input: {
          productUuid,
          file,
          execute,
        },
      },
    });
    const { itemsImport } = data;

    const importStatus = execute ? IMPORT_STATUS.done : IMPORT_STATUS.ready;

    this.setState({
      itemsImport,
      importStatus,
    });
  };

  handleImportExecute = async () => {
    this.handleImport({ execute: true });
  };

  handleFileChange = ({
    target: {
      validity,
      files: [file],
    },
  }) => {
    if (validity.valid) {
      this.setState({
        file,
      });
    } else {
      console.log(validity); // eslint-disable-line no-console
      alert('file is not valid'); // eslint-disable-line no-alert
    }
  };

  render() {
    const { itemsImport, importStatus } = this.state;

    const disabled = importStatus !== IMPORT_STATUS.ready;
    const done = importStatus === IMPORT_STATUS.done;

    return (
      <div>
        {itemsImport ? (
          <div>
            <h4>Import summary</h4>
            <ul>
              {itemsImport.createCount > 0 && (
                <li>Create {pluralize('item', itemsImport.createCount, true)}</li>
              )}
              {itemsImport.updateCount > 0 && (
                <li>Update {pluralize('item', itemsImport.updateCount, true)}</li>
              )}
              {itemsImport.deleteCount > 0 && (
                <li>Delete {pluralize('item', itemsImport.deleteCount, true)}</li>
              )}
            </ul>
            {done ? (
              <div>
                <p>Import successful.</p>
              </div>
            ) : itemsImport.errors.length === 0 ? (
              <div>
                <p>No errors automatically detected.</p>
                <p>
                  If this is what you intended:{' '}
                  <Button onClick={this.handleImportExecute} disabled={disabled}>
                    Live Run!
                  </Button>
                </p>
              </div>
            ) : (
              <ReactJson src={itemsImport.errors} shouldCollapse={shouldCollapse} />
            )}
          </div>
        ) : (
          <div>
            <input type="file" required onChange={this.handleFileChange} />
            <Button onClick={this.handleImport} disabled={disabled}>
              Dry Run
            </Button>
            <p>Import status: {importStatus}</p>
          </div>
        )}
      </div>
    );
  }
}

export default withApollo(FlashcardsImport);
